import moment from 'moment'

// utils
const tableState = column => ({
  sort: { column, desc: false },
  pagination: {}
})

// filter module definition
const module = (filters, sort) => ({
  namespaced: true,

  state: {
    filters: filters,
    table: tableState(sort)
  },

  mutations: {
    saveFilters (state, value) {
      state.filters = value
    },

    saveTable (state, value) {
      state.table = value
    }
  }
})

// filters module
export default {
  namespaced: true,

  modules: {
    issues: module({
      type: null,
      users: null,
      assets: null,
      assetTypes: null,
      issueCodes: null,
      closed: false
    }, 'actionAt'),

    assets: module({
      search: null,
      assetTypes: null,
      deviceTypes: null
    }, 'name'),

    interventions: module({
      type: null,
      users: null,
      assets: null,
      assetTypes: null,
      interval: {
        from: moment().startOf('day').subtract(1, 'month').valueOf(),
        to: moment().startOf('day').valueOf()
      }
    }, 'actionAt')
  }
}
